import React, { useEffect } from 'react';
import CustomSelect from '../../components/CustomSelect';
import {
  useGetCustomSelectButtonElement,
  useSetSelectDefaultValue,
} from '../../hooks/init';
import { SingleCommonType } from '../../types';
import { reviewTimePlaceholder } from '../../constants/placeholder';
import { commonBackInfo } from '../../utils';
import useLanguage from '@/pages/opinion/hooks/useLanguage';
import { NO_DATE } from '@/pages/opinion/constants';
import {
  recordTimesMap,
  recordTimesOptions,
} from '../../constants/recordTimes';
import { FilterButtonPoint } from '@op/operationLog/pages/filter';

export default function ReviewTimesSelect({
  onChange,
  defaultValue,
  filterValue,
  defaultKey,
  lang,
}: SingleCommonType) {
  const {
    selects: reviewTimesSelects,
    setSelects: setReviewTimesSelects,
    diffClassName,
  } = useSetSelectDefaultValue<string>({
    defaultValue,
    filterValue,
    defaultKey: 'review_times',
    options: recordTimesOptions.map((item) => item.value),
  });

  const { formatMessage } = useLanguage();

  const { customSelectRef, getButtonElement } =
    useGetCustomSelectButtonElement();

  useEffect(() => {
    const [text, isAll] = getButtonElement();
    onChange?.(
      'reviewTimes',
      commonBackInfo(
        { review_times: reviewTimesSelects },
        { [defaultKey]: text },
        { needChangeEntity: true, isAll },
      ),
    );
  }, [reviewTimesSelects, formatMessage]);

  return (
    <div className={`review-times-select-wrapper ${diffClassName}`}>
      <CustomSelect
        ref={customSelectRef}
        placeholderText={reviewTimePlaceholder[lang]}
        onClear={() => setReviewTimesSelects([])}
        buttonItemRender={(item: string) =>
          formatMessage({ id: recordTimesMap[item] || NO_DATE.EMPTY })
        }
        showNumber={3}
        selectOptionsInfo={[reviewTimesSelects, setReviewTimesSelects]}
        options={recordTimesOptions}
        pointKey={FilterButtonPoint.reviewTimes}
      ></CustomSelect>
    </div>
  );
}
